export const TAGS_VISIBLE_IN_TYPE = {
  OrgChart: "OrgChart",
  TeamProfileHeader: "TeamProfileHeader",
  TagProfileHeader: "TagProfileHeader",
  PersonProfileHeader: "PersonProfileHeader",
  Directory: "Directory",
  Teamform: "Teamform",
  IndividualsHistory: "IndividualsHistory",
  Navigation: "Navigation",
  SkillsRequirement: "SkillsRequirement",
  Planner: "Planner",
  Forecasting: "Forecasting",
  AppliedCountTooltip: "AppliedCountTooltip",
  TagHierarchyAsParent: "TagHierarchyAsParent",
  FeaturedTagWidget: "FeaturedTagWidget",
};

export const INITIAL_TAGS_VISIBLE_IN_COMPONENTS_LIST = [
  TAGS_VISIBLE_IN_TYPE.Directory,
  TAGS_VISIBLE_IN_TYPE.Teamform,
  TAGS_VISIBLE_IN_TYPE.IndividualsHistory,
  TAGS_VISIBLE_IN_TYPE.Navigation,
  TAGS_VISIBLE_IN_TYPE.SkillsRequirement,
  TAGS_VISIBLE_IN_TYPE.AppliedCountTooltip,
  TAGS_VISIBLE_IN_TYPE.OrgChart,
];

export const TAGS_VISIBLE_IN_COMPONENTS_LIST = [
  {
    key: TAGS_VISIBLE_IN_TYPE.Directory,
    label: "Directory",
    value: TAGS_VISIBLE_IN_TYPE.Directory,
  },
  {
    key: TAGS_VISIBLE_IN_TYPE.Teamform,
    label: "TeamForm",
    value: TAGS_VISIBLE_IN_TYPE.Teamform,
  },
  {
    key: TAGS_VISIBLE_IN_TYPE.IndividualsHistory,
    label: "Individual's history",
    value: TAGS_VISIBLE_IN_TYPE.IndividualsHistory,
  },
  {
    key: TAGS_VISIBLE_IN_TYPE.Navigation,
    label: "Navigation",
    value: TAGS_VISIBLE_IN_TYPE.Navigation,
  },
  {
    key: TAGS_VISIBLE_IN_TYPE.SkillsRequirement,
    label: "Skills requirement",
    value: TAGS_VISIBLE_IN_TYPE.SkillsRequirement,
  },
  {
    key: TAGS_VISIBLE_IN_TYPE.Planner,
    label: "Planner",
    value: TAGS_VISIBLE_IN_TYPE.Planner,
  },
  {
    key: TAGS_VISIBLE_IN_TYPE.Forecasting,
    label: "Forecasting",
    value: TAGS_VISIBLE_IN_TYPE.Forecasting,
  },
  {
    key: TAGS_VISIBLE_IN_TYPE.AppliedCountTooltip,
    label: "Applied count tooltip",
    value: TAGS_VISIBLE_IN_TYPE.AppliedCountTooltip,
  },
  {
    key: TAGS_VISIBLE_IN_TYPE.OrgChart,
    label: "Org Chart",
    value: TAGS_VISIBLE_IN_TYPE.OrgChart,
  },
  {
    key: TAGS_VISIBLE_IN_TYPE.TeamProfileHeader,
    label: "Team Profile Header",
    value: TAGS_VISIBLE_IN_TYPE.TeamProfileHeader,
  },
  {
    key: TAGS_VISIBLE_IN_TYPE.TagProfileHeader,
    label: "Tag Profile Header",
    value: TAGS_VISIBLE_IN_TYPE.TagProfileHeader,
  },
  {
    key: TAGS_VISIBLE_IN_TYPE.PersonProfileHeader,
    label: "Person Profile Header",
    value: TAGS_VISIBLE_IN_TYPE.PersonProfileHeader,
  },
  {
    key: TAGS_VISIBLE_IN_TYPE.TagHierarchyAsParent,
    label: "Tag Hierarchy as Parent",
    value: TAGS_VISIBLE_IN_TYPE.TagHierarchyAsParent,
  },
  {
    key: TAGS_VISIBLE_IN_TYPE.FeaturedTagWidget,
    label: "Featured Tag Widget",
    value: TAGS_VISIBLE_IN_TYPE.FeaturedTagWidget,
  },
];

export const TAG_CONFIG_FIELDS = [
  "allowGroupToHaveTag",
  "allowPersonToHaveTag",
  "allowMultipleOnEntity",
  "allowNewTags",
  "showPreviousAppliedTags",
  "details",
  "id",
  "isReserved",
  "name",
  "isEditableByUsers",
  "isGroupBadge",
  "isGroupAssociation",
  "allowedToEditTagDisplayValue",
  "isPersonBadge",
  "readOnly",
  "allowEditingReadOnlyTagsByAdmin",
  "allowEditingReadOnlyTagsByPowerUser",
  "hideShowInfoIconInTagDisplay",
  "hideTagTypeInTagDisplay",
  "showInExplore",
  "isActive",
];

export const ATTRIBUTE_ROW_TYPE = {
  values: "values",
  others: "others",
  entityTag: "entityTag",
  parentTag: "parentTag",
};

export const DEFAULT_ALLOWED_GROUP_TYPE = {
  key: "ALL",
  label: "All types",
  value: "ALL",
};

// New filter options for group types
export const ALL_DEMAND_GROUP_TYPES = {
  key: "ALL_DEMAND",
  label: "All demand types",
  value: "ALL_DEMAND",
};

export const ALL_SUPPLY_GROUP_TYPES = {
  key: "ALL_SUPPLY",
  label: "All supply types",
  value: "ALL_SUPPLY",
};

export const ALL_DOES_NOT_PARTICIPATE_GROUP_TYPES = {
  key: "ALL_DOES_NOT_PARTICIPATE",
  label: "All does not participate types",
  value: "ALL_DOES_NOT_PARTICIPATE",
};

export const ADD_NEW_TAG_LINK = {
  id: "__AddNew__",
  label: "+ Add new value",
  isActive: true,
  isTagValue: false,
};

export const ACTIVE_TAG_TYPES_GROUP = {
  id: "__ActiveTagTypesGroup__",
  name: "Active",
  isTagTypeGroup: true,
};

export const INACTIVE_TAG_TYPES_GROUP = {
  id: "__InactiveTagTypesGroup__",
  name: "Inactive",
  isTagTypeGroup: true,
};

export const LOAD_MORE_TAGS_LINK = {
  id: "__LoadMore__",
  label: "+ Load more tags",
  isActive: true,
  isTagValue: true,
  isLoadMoreTags: true,
};

export const NO_MORE_RESULTS_ID = "no-more-results";
export const REPORTS_RESOURCE_CREATION_STATUS = {
  SUBMITTED: "SUBMITTED",
  PENDING: "PENDING",
  RUNNABLE: "RUNNABLE",
  STARTING: "STARTING",
  RUNNING: "RUNNING",
  SUCCEEDED: "SUCCEEDED",
  FAILED: "FAILED",
};
